export default __webpack_public_path__ + "static/media/ic_logout.77b07e5e.svg";